import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { getFilterParams } from 'src/deps'
import { Row, Col } from 'react-bootstrap'
import { i18nTranslate } from 'src/utils'
import { application } from 'src/utils'
import { loyaltyContainer } from 'src/models'
import { dateFormatDeps } from 'src/deps'
import { ServiceErrorUI } from 'src/views/components'
import { headerListArray } from './fixture'
import {
  IoIosArrowForward as ArrowForwardIcon,
  IoIosArrowBack as ArrowBackwardIcon,
} from 'react-icons/io'
import './styles.scss'

const rewardStatusTypes = ['redeemed', 'forfeited', 'expired']

@observer
class WalletBlock extends React.Component {
  @observable loyaltyHistory = []
  @observable transactionArray = []
  @observable page = 1
  @observable isApiInProgress = false
  @observable isLoyaltyLoading = true
  //Fix for EQPLAT-12720 UTCdate
  UTCdate = true
  getTransactionLimit = () => {
    const queryParam = this.props.location?.queryParams
    const defaultLimit = 10
    const limit = queryParam.limit || defaultLimit
    return limit
  }

  getTransactionArray = () => {
    this.transactionArray = this.loyaltyHistory.transactions || []
    let forfeitedIndex = this.transactionArray.length
    let forfeitedIndexUpdate = false
    this.transactionArray.forEach((transactionData, index) => {
      const transactionArrayProps = transactionData?.properties || []
      const csrReasonDisplayNameArray = transactionArrayProps.filter(el => {
        return el.name == 'csrReasonDisplayName'
      })
      const csrReasonDisplayNameVal =
        csrReasonDisplayNameArray.length > 0
          ? csrReasonDisplayNameArray[0].value.trim().toLowerCase()
          : ''
      const transactionDataChannel =
        transactionData?.channel?.toLowerCase() || ''
      if (
        transactionData?.notes?.toLowerCase() === 'forfeited' &&
        transactionDataChannel !== 'csr' &&
        csrReasonDisplayNameVal !== 'adjustment' &&
        !forfeitedIndexUpdate
      ) {
        forfeitedIndex = index
        forfeitedIndexUpdate = true
      }
    })
    this.transactionArray =
      this.transactionArray.length > 0
        ? this.transactionArray.slice(0, forfeitedIndex)
        : this.transactionArray
  }

  getTransactionListData = async isPagination => {
    const queryParams = getFilterParams(
      typeof location != 'undefined' ? location : {}
    )
    const params = {
      page: queryParams.page || this.page,
      size: this.getTransactionLimit(),
    }
    const response = await loyaltyContainer.getLoyaltyTransactionsList(params)

    this.loyaltyHistory = response
    this.isLoyaltyLoading = false
    this.getTransactionArray()
    this.isApiInProgress = false
  }
  getTransactionPageWise = page => {
    if (!this.isApiInProgress) {
      this.page = page
      this.isApiInProgress = true
      this.getTransactionListData(true)
    }
  }
  async componentDidMount() {
    await this.getTransactionListData()
  }
  getRewardType = loyaltyData => {
    const rewardType = loyaltyData?.type || ''
    const rewardStatus = rewardStatusTypes.includes(rewardType.toLowerCase())
    const rewardValueClass = rewardStatus ? 'transaction-value-negative' : ''
    const rewardValue = rewardStatus ? '-' : ''
    return { rewardValueClass, rewardValue }
  }
  renderLoyaltyTransactionHeader = () => {
    return (
      <Row noGutters className="loyalty-points-history py-3" role="row">
        {headerListArray.map((headerList, idx) => {
          if (headerList.hide) {
            return ''
          }
          return (
            <Col
              className="loyalty-wrap-text"
              role="columnheader"
              key={`${idx}loyalty`}>
              <span className="loyalty-points-history-table-text mb-auto text-uppercase paragraph-m-bold">
                {headerList.label}
              </span>
            </Col>
          )
        })}
      </Row>
    )
  }
  renderData = loyaltyData => {
    const { rewardValueClass, rewardValue } = this.getRewardType(loyaltyData)
    if (loyaltyData.hide) {
      return ''
    }
    return (
      <Col sm={12} key={`${loyaltyData.label}-${loyaltyData.value}`}>
        <span>{loyaltyData.label}</span>:
        <span className={`${rewardValueClass} pl-2`}>
          {rewardValue}
          {loyaltyData.value}
        </span>
      </Col>
    )
  }
  constructData = (loyaltyData, index) => {
    const createdTime =
      loyaltyData?.effectiveDate || loyaltyData?.createdOn || ''
    const expirydate = loyaltyData?.expiryTime || ''
    const arrayList = [
      {
        label: i18nTranslate('loyalty.date', 'Date Of Action').toUpperCase(),
        value:
          (createdTime &&
            dateFormatDeps.getMonthInString(createdTime, this.UTCdate)) ||
          '',
      },
      {
        label: i18nTranslate('loyalty.type', 'Action Type').toUpperCase(),
        value: loyaltyData?.type || '',
      },
      // {
      //   label: i18nTranslate('loyalty.expirydate', 'Date Of Expiry').toUpperCase(),
      //   value:
      //     (expirydate &&
      //       dateFormatDeps.getMonthInString(expirydate, this.UTCdate)) ||
      //     'N/A',
      //   // hide: storeContainer.isCARegion(),
      // },
      {
        label: i18nTranslate('loyalty.order', 'Order #').toUpperCase(),
        value: loyaltyData?.orderId || '',
      },
      {
        label: i18nTranslate('loyalty.points', 'Reward Points').toUpperCase(),
        value:
          '$' + loyaltyData?.rewardValue?.toFixed(2) ||
          '$' + loyaltyData?.rewardValue ||
          '',
        type: loyaltyData?.type || '',
      },
    ]
    return (
      <Row
        noGutters
        className="transaction-wrap border-bottom py-3"
        key={`loyalty-history-${index}`}>
        {arrayList.map(this.renderData)}
      </Row>
    )
  }

  renderTableData = (loyaltyData, index) => {
    const createdTime =
      loyaltyData?.effectiveDate || loyaltyData?.createdOn || ''
    const date = createdTime
      ? dateFormatDeps.getMonthInString(createdTime, this.UTCdate)
      : ''
    const expirydate = loyaltyData?.expiryTime || ''
    const disableExpDate =
      (loyaltyData?.type || '').toUpperCase() === 'REDEEMED' ||
      (loyaltyData?.type || '').toUpperCase() === 'FORFEITED'
        ? true
        : false
    const expDate = disableExpDate
      ? ''
      : expirydate
      ? dateFormatDeps.getMonthInString(expirydate, this.UTCdate)
      : ''
    const { rewardValueClass, rewardValue } = this.getRewardType(loyaltyData)
    return (
      <Row
        noGutters
        className=" loyalty-titleheader py-3 w-100 paragraph-m"
        role="row"
        data-testid="qa-user-loyalty-transaction"
        key={`loyaltyhistory-${index}`}>
        <Col role="cell">
          <span
            className="transaction-value"
            data-testid="qa-user-loyalty-transaction-date">
            {date}
          </span>
        </Col>
        <Col role="cell">
          <span
            className="transaction-value"
            data-testid="qa-user-loyalty-transaction-type">
            {loyaltyData?.type || ''}
          </span>
        </Col>
        {/* {!storeContainer.isCARegion() && ( */}
        {/* {
          <Col role="cell">
            <span
              className="transaction-value"
              data-testid="qa-user-loyalty-transaction-expiry-date">
              {expDate}
            </span>
          </Col>
        } */}
        <Col role="cell">
          <span
            className="transaction-value"
            data-testid="qa-user-loyalty-transaction-order-id">
            {loyaltyData?.orderId || ''}
          </span>
        </Col>
        <Col className="transaction-row" role="cell">
          <span
            className={`transaction-value ${rewardValueClass}`}
            data-testid="qa-user-loyalty-transaction-points">
            {rewardValue}
            {'$' + loyaltyData?.rewardValue?.toFixed(2) ||
              '$' + loyaltyData?.rewardValue ||
              ''}
          </span>
        </Col>
      </Row>
    )
  }
  renderServiceFailure = () => {
    return (
      <div className="err-subscription mb-2">
        <ServiceErrorUI />
      </div>
    )
  }
  render() {
    const transactionArray = this.transactionArray
    const totalCount = this.loyaltyHistory?.pageableInfo?.totalCount || 0
    const noOfPages =
      totalCount >= 1 ? Math.ceil(totalCount / this.getTransactionLimit()) : 1 //no of pages
    const paginationDropBox = [...Array(noOfPages).keys()].map(i => i + 1)
    const apiStatus = this.loyaltyHistory?.apiStatus || ' '
    const isServiceFailure = this.loyaltyHistory?.isServiceFailure || false

    if (apiStatus == 'failure' && isServiceFailure) {
      return this.renderServiceFailure()
    } else if (transactionArray?.length) {
      return (
        <React.Fragment>
          <div
            className=" loyalty-content table-content"
            role="rowgroup"
            data-testid="qa-user-loyalty-history-table">
            {!application.isMobile && this.renderLoyaltyTransactionHeader()}
            <div className="card-group orderhistory-page loyalty-points-history-data">
              {transactionArray.map((transactionData, index) => {
                return application.isMobile
                  ? this.constructData(transactionData, index)
                  : this.renderTableData(transactionData, index)
              })}
            </div>
          </div>
          <div className="loyalty-pagination d-flex align-items-center justify-content-end">
            <div className="loyalty-selectBox-container">
              <select
                className="loyalty-selectBox"
                value={this.page}
                onChange={event => {
                  this.getTransactionPageWise(event.target.value)
                }}>
                {paginationDropBox.map(item => {
                  return (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  )
                })}
              </select>
            </div>
            <ArrowBackwardIcon
              className={`loyalty-backward-arrow
                ${this.page == 1 ? ' disabled' : ''}
              `}
              onClick={event => {
                if (this.page != 1) this.getTransactionPageWise(this.page - 1)
              }}
            />
            <ArrowForwardIcon
              className={`loyalty-forward-arrow
                ${this.page == noOfPages ? ' disabled' : ''}
              `}
              onClick={event => {
                if (this.page != noOfPages)
                  this.getTransactionPageWise(+this.page + 1)
              }}
            />
            <div className="loyalty-pagination-text">
              {`page ${this.page} of ${noOfPages}`}
            </div>
          </div>
        </React.Fragment>
      )
    } else if (!this.isLoyaltyLoading) {
      return (
        <div
          className="d-flex justify-content-center loyalty-content table-content"
          data-testid="qa-user-loyalty-history-table">
          {i18nTranslate('loyalty.noTransactionText', 'No Transaction History')}
        </div>
      )
    } else {
      return <React.Fragment />
    }
  }
}

export { WalletBlock }
